import tomato from '../assets/player-effects/tomato.svg';
import potato from '../assets/player-effects/potato.svg';
import bomb from '../assets/player-effects/bomb.svg';
import egg from '../assets/player-effects/egg.svg';
import hammer from '../assets/player-effects/hammer.svg';
import poop from '../assets/player-effects/poop.svg';
import fire from '../assets/player-effects/fire.svg';
import snowflake from '../assets/player-effects/snowflake.svg';
import water from '../assets/player-effects/water.svg';
import lightning from '../assets/player-effects/lightning.svg';
import rock from '../assets/player-effects/rock.svg';
import boxingGlove from '../assets/player-effects/boxing-glove.svg';
import shoe from '../assets/player-effects/shoe.svg';
import soccer from '../assets/player-effects/soccer.svg';
import basketball from '../assets/player-effects/basketball.svg';
import baseball from '../assets/player-effects/baseball.svg';
import football from '../assets/player-effects/football.svg';
import frisbee from '../assets/player-effects/frisbee.svg';
import banana from '../assets/player-effects/banana.svg';
import watermelon from '../assets/player-effects/watermelon.svg';
import pineapple from '../assets/player-effects/pineapple.svg';
import pizza from '../assets/player-effects/pizza.svg';
import cake from '../assets/player-effects/cake.svg';
import chili from '../assets/player-effects/chili.svg';
import onion from '../assets/player-effects/onion.svg';
import garlic from '../assets/player-effects/garlic.svg';
import cheese from '../assets/player-effects/cheese.svg';
import ice from '../assets/player-effects/ice.svg';
import ghost from '../assets/player-effects/ghost.svg';
import clown from '../assets/player-effects/clown.svg';
import rocket from '../assets/player-effects/rocket.svg';
import party from '../assets/player-effects/party.svg';
import star from '../assets/player-effects/star.svg';
import crown from '../assets/player-effects/crown.svg';
import gift from '../assets/player-effects/gift.svg';
import thumbsUp from '../assets/player-effects/thumbs-up.svg';
import laugh from '../assets/player-effects/laugh.svg';
import angry from '../assets/player-effects/angry.svg';
import kiss from '../assets/player-effects/kiss.svg';
import hug from '../assets/player-effects/hug.svg';
import flowers from '../assets/player-effects/flowers.svg';
import heart from '../assets/player-effects/heart.svg';
import brokenHeart from '../assets/player-effects/broken-heart.svg';
import sparklingHeart from '../assets/player-effects/sparkling-heart.svg';

const effect = (id, image, category) => Object.freeze({ id, image, category });

export const PLAYER_EFFECTS = Object.freeze([
  effect('tomato', tomato, 'throw'), effect('potato', potato, 'throw'), effect('egg', egg, 'throw'),
  effect('hammer', hammer, 'throw'), effect('bomb', bomb, 'throw'), effect('poop', poop, 'throw'),
  effect('fire', fire, 'throw'), effect('snowflake', snowflake, 'throw'), effect('water', water, 'throw'),
  effect('lightning', lightning, 'throw'), effect('rock', rock, 'throw'), effect('boxing-glove', boxingGlove, 'throw'),
  effect('shoe', shoe, 'throw'), effect('soccer', soccer, 'throw'), effect('basketball', basketball, 'throw'),
  effect('baseball', baseball, 'throw'), effect('football', football, 'throw'), effect('frisbee', frisbee, 'throw'),

  effect('banana', banana, 'food'), effect('watermelon', watermelon, 'food'), effect('pineapple', pineapple, 'food'),
  effect('pizza', pizza, 'food'), effect('cake', cake, 'food'), effect('chili', chili, 'food'),
  effect('onion', onion, 'food'), effect('garlic', garlic, 'food'), effect('cheese', cheese, 'food'), effect('ice', ice, 'food'),

  effect('ghost', ghost, 'fun'), effect('clown', clown, 'fun'), effect('rocket', rocket, 'fun'),
  effect('party', party, 'fun'), effect('star', star, 'fun'), effect('crown', crown, 'fun'),
  effect('gift', gift, 'fun'), effect('thumbs-up', thumbsUp, 'fun'), effect('laugh', laugh, 'fun'), effect('angry', angry, 'fun'),

  effect('kiss', kiss, 'kind'), effect('hug', hug, 'kind'), effect('flowers', flowers, 'kind'),
  effect('heart', heart, 'kind'), effect('broken-heart', brokenHeart, 'kind'), effect('sparkling-heart', sparklingHeart, 'kind'),
]);

export const getPlayerEffect = effectId => PLAYER_EFFECTS.find(item => item.id === effectId);
